import { Injectable } from "@angular/core";
import { LiquidParserService } from "./liquid.parser.service";
import { Liquid } from "liquidjs";
import { HttpResponseMessage } from "../models/models";


@Injectable({
  providedIn: "root",
})
export class LiquidService
{
  engine: Liquid;
  
  dictParams: { [key: string]: any } = {};
  constructor(public lps: LiquidParserService) {
    this.engine = new Liquid({cache:true});
  }

     

}
